module.exports = __webpack_public_path__ + "static/media/tip7.8dfbdf86.svg";